import styled, { keyframes } from "styled-components";


export const Modal = styled.div`
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    height: 110vh;
    background-color: rgb(44, 62, 80, 0.8);
    z-index: 1000;
    top: 0;
`

export const Action = styled.div`
    background-color: white;
    width: 90vw;
    height: 10vh;
    border-radius: 15px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
`

export const Center = styled.div`
    background-color: white;
    width: 90vw;
    height: 70vh;
    border-radius: 15px;
    position: relative;
    margin: 20px 0;
    padding-top: 10%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
`

export const BottonText = styled.div`
    position: absolute;
    bottom: 0;
`

export const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 20px;
  position: relative;
  width: 90vw;
  min-height: 45vh;
  max-height: 50vh;
  overflow-y: hidden;

`

const enterFromBottom = keyframes`
  0% {
    opacity: 0;
    transform: translateY(200px) scale(0.8);
    position: absolute;
  }
  25% {
    opacity: 0;
    transform: translateY(200px) scale(0.8);
    position: absolute;
  }
  50% {
    opacity: 1;
    transform: translateY(-10px) scale(1.05);
    position: absolute;
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
    position: relative;
  }
`;

// Animación de agitación para el dorsal
const shakeAnimation = keyframes`
  0%, 100% { transform: translateX(0) rotateZ(2deg); }
  25% { transform: translateX(-5px) rotateZ(-2deg); }
  75% { transform: translateX(5px) rotateZ(2deg); }
`;

export const Carta = styled.img`
    width: 23vw;
    opacity: 0;
    margin: 0px 0px;
    border-radius: 10px;
    animation: ${enterFromBottom} 2s cubic-bezier(0.7, 2, 0.5, 1) forwards;
    animation-delay: ${({ delay }) => delay || '0s'};
    filter: drop-shadow(2px 1px 1px rgba(0,0,0,0.49));
`

const fadeOut = keyframes`
  to {
    opacity: 0;
    visibility: hidden;
  }
`;
export const DorsalImage = styled.img`
  position: absolute;
  animation: ${shakeAnimation} 0.3s ease-in-out 5, ${fadeOut} 0.5s ease 1.6s forwards;
  pointer-events: none; /* Evita que interfiera con el clic en las cartas */
  opacity: 1;
  bottom: 0;
  width: 23vw;
  border-radius: 10px;
  z-index: 6002;
`;

export const FullDiv = styled.div`
    width: 100vw;
    height: 100vh;
    z-index: 6000;
    position: absolute;
    background-color: rgb(44, 62, 80, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    perspective: 1000px;
    top: 0;
`

// Animación de rotación para la imagen frontal
const frontFlip = keyframes`
    0% {
    transform: rotateY(180deg); /* Comienza en 180 grados */
    z-index: 0; /* BackImage al frente */
    }
    100% {
    transform: rotateY(360deg); /* Gira a 0 grados (FrontImage al frente) */
    z-index: 2; /* FrontImage al frente */
    }
    `;

    // Animación de rotación para la imagen trasera
    const backFlip = keyframes`
    0% {
    transform: rotateY(0deg);
    z-index: 2;
    }
    100% {
    transform: rotateY(180deg);
    z-index: 0;
    }
`;

const Image = styled.img`
    position: absolute;
    max-height: 70vh;
    max-width: 90vw;
    border-radius: 15px;
    backface-visibility: hidden; 
`;

export const FullCarta = styled(Image)`
  animation: ${frontFlip} 1.5s ease 1; /* 6 segundos de animación */
  z-index: 2;
  ${({ fixed }) => `
    margin-top: ${fixed == "true" ? "-160px" : ""};
  `}

`

export const FullTapa = styled(Image)`
  transform: rotateY(180deg);
  animation: ${backFlip} 1.5s ease 1; /* 6 segundos de animación */
  z-index: 0;
  ${({ fixed }) => `
    margin-top: ${fixed == "true" ? "-160px" : ""};
  `}
`

export const CloseButton = styled.div`
    background-color: white;
    border-radius: 50%;
    width: 45px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 18px;
    position: absolute;
    bottom: 0;
    margin-bottom: 12vh;
`

export const DeleteButton = styled.div`
    background-color: rgb(236,110,111);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 19px;
    position: absolute;
    bottom: 0;
    right: 0;
    margin-bottom: 12.2vh;
    margin-right: 20px;
`